<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input v-model="search.name" placeholder="任务名称" class="filter-item" style="width: 300px;" @keyup.enter.native="handleFilter"/>
      <el-button v-waves type="primary" class="filter-item" icon="el-icon-search" @click="handleFilter">查询</el-button>
      <el-button type="success" class="filter-item" style="margin-left: 10px;" icon="el-icon-s-flag" @click="handleCreate">添加预测任务</el-button>
    </div>

    <el-table v-loading="listLoading" :key="tableKey" :data="list" border fit highlight-current-row style="width: 100%;">
      <el-table-column label="任务名称" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="项目" width="200px">
        <template slot-scope="scope">
          <span>{{ scope.row.project }}</span>
        </template>
      </el-table-column>
      <el-table-column label="机台" width="200px">
        <template slot-scope="scope">
          <span>{{ scope.row.dev }}</span>
        </template>
      </el-table-column>
      <el-table-column label="色谱柱" width="200px">
        <template slot-scope="scope">
          <span>{{ scope.row.spectrum }}</span>
        </template>
      </el-table-column>
      <el-table-column label="类别" width="120px">
        <template slot-scope="scope">
          <span>{{ scope.row.cate_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="时间" align="center" width="140px">
        <template slot-scope="scope">
          <span>{{ scope.row.time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" width="140px">
        <template slot-scope="scope">
          <span>{{ scope.row.status | statusFilter }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" fixed="right" width="100" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-tooltip content="编辑" class="item" effect="dark" placement="bottom" v-if="scope.row.status != '1'">
            <el-button type="text" class="btn-text" @click="handleEdit(scope.row)">
              <svg-icon icon-class="edit"/>
            </el-button>
          </el-tooltip>
          <el-tooltip content="任务内容" class="item" effect="dark" placement="bottom" v-if="scope.row.status == '1'">
            <el-button type="text" class="btn-text" @click="handleEdit(scope.row)">
              <svg-icon icon-class="see"/>
            </el-button>
          </el-tooltip>
          <el-tooltip content="执行任务" class="item" effect="dark" placement="bottom" v-if="scope.row.status != '1'">
            <el-button type="text" class="btn-text" @click="doTask(scope.row.id)">
              <svg-icon icon-class="run"/>
            </el-button>
          </el-tooltip>
          <el-tooltip content="预测结果" class="item" effect="dark" placement="bottom" v-if="scope.row.status == '1'">
            <el-button type="text" class="btn-text" @click="doTask(scope.row.id)">
              <svg-icon icon-class="forecast"/>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container right">
      <el-pagination v-show="total > search.size" :current-page="search.page" :page-size="search.size" :total="total" layout="total, prev, pager, next" @current-change="handleCurrentChange"/>
    </div>

    <el-dialog class="dia" :title="temp.status == '1'? '任务内容': !temp.id? '添加': '编辑'" top="1vh" width="95%" :close-on-click-modal="false" :visible.sync="dia.edit">
      <el-row :gutter="20">
        <el-col :span="10" style="border-right: 1px dashed #ddd;">
          <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="140px" style="margin-left:20px;">
            <el-form-item label="任务ID" prop="code" v-if="temp.id">
              <span>{{ temp.id }}</span>
            </el-form-item>
            <el-form-item label="任务名称" prop="name">
              <el-input v-model="temp.name" placeholder="请填写任务名称" style="width: 90%" :disabled="temp.status == '1'"/>
            </el-form-item>
            <el-form-item label="项目" prop="pid">
              <el-select v-model="temp.pid" placeholder="请选择" style="width: 90%" :disabled="temp.status == '1'">
                <el-option v-for="row in option.project" :key="row.id" :label="row.name" :value="row.id"></el-option>
              </el-select>
              <el-popover placement="right" width="250" trigger="hover" v-if="temp.pid">
                <div v-for="(v, idx) in showInfo(option.project, temp.pid, tip.project)" :key="idx">{{v}}</div>
                <i class="el-icon-info info" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="机台" prop="did">
              <el-select v-model="temp.did" placeholder="请选择" style="width: 90%" :disabled="temp.status == '1'">
                <el-option v-for="row in option.dev" :key="row.id" :label="row.sn" :value="row.id"></el-option>
              </el-select>
              <el-popover placement="right" width="250" trigger="hover" v-if="temp.did">
                <div v-for="(v, idx) in showInfo(option.dev, temp.did, tip.dev)" :key="idx">{{v}}</div>
                <i class="el-icon-info info" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="色谱柱" prop="sid">
              <el-select v-model="temp.sid" placeholder="请选择" style="width: 90%" :disabled="temp.status == '1'">
                <el-option v-for="row in option.spectrum" :key="row.id" :label="row.name" :value="row.id"></el-option>
              </el-select>
              <el-popover placement="right" width="250" trigger="hover" v-if="temp.sid">
                <div v-for="(v, idx) in showInfo(option.spectrum, temp.sid, tip.spectrum)" :key="idx">{{v}}</div>
                <i class="el-icon-info info" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="类别" prop="cate">
              <el-select v-model="temp.cate" placeholder="请选择" style="width: 90%" :disabled="temp.status == '1'">
                <el-option v-for="row in option.cate" :key="row.k" :label="row.v" :value="row.k"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="初始流动相组成" prop="f0">
              <el-input-number v-model="temp.f0" controls-position="right" :min="0" :max="100" :disabled="temp.status == '1'"></el-input-number> %
              <el-popover placement="right" width="250" trigger="hover">
                <div v-for="(v, idx) in note.f0" :key="idx">{{v}}</div>
                <i class="el-icon-info info" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="终止流动相组成" prop="f1">
              <el-input-number v-model="temp.f1" controls-position="right" :min="0" :max="100" :disabled="temp.status == '1'"></el-input-number> %
            </el-form-item>
            <el-form-item label="流速(mL/min)" prop="vof">
              <el-input v-model="temp.vof" placeholder="请输入流速" clearable :disabled="temp.status == '1'"></el-input>
            </el-form-item>
            <el-form-item label="溶剂A" prop="sa">
              <el-input v-model="temp.sa" placeholder="请输入溶剂A信息" clearable :disabled="temp.status == '1'"></el-input>
            </el-form-item>
            <el-form-item label="溶剂B" prop="sb">
              <el-input v-model="temp.sb" placeholder="请输入溶剂B信息" clearable :disabled="temp.status == '1'"></el-input>
            </el-form-item>
            <el-divider>梯度条件参数</el-divider>
            <el-form-item label="分析时间(min)" prop="h_duringt">
              <el-input v-model="temp.h_duringt" placeholder="请输入分析时间" clearable :disabled="temp.status == '1'" style="width: 90%"></el-input>
              <el-popover placement="right" width="250" trigger="hover">
                <div v-for="(v, idx) in note.h_duringt" :key="idx">{{v}}</div>
                <i class="el-icon-info info" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="梯度线段的数目" prop="h_tptn">
              <el-input-number v-model="temp.h_tptn" controls-position="right" :min="0" :max="100" :disabled="temp.status == '1'"></el-input-number>
              <el-popover placement="right" width="250" trigger="hover">
                <div v-for="(v, idx) in note.h_tptn" :key="idx">{{v}}</div>
                <i class="el-icon-info info" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="初始流动相 最小值" prop="h_mp0val_b">
              <el-input-number v-model="temp.h_mp0val_b" controls-position="right" :min="0" :max="100" :disabled="temp.status == '1'"></el-input-number> %
              <el-popover placement="right" width="250" trigger="hover">
                <div v-for="(v, idx) in note.h_mp0val_b" :key="idx">{{v}}</div>
                <i class="el-icon-info info" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="初始流动相 最大值" prop="h_mp0val_e">
              <el-input-number v-model="temp.h_mp0val_e" controls-position="right" :min="0" :max="100" :disabled="temp.status == '1'"></el-input-number> %
            </el-form-item>
            <el-form-item label="初始流动相 个数" prop="h_mp0n">
              <el-input-number v-model="temp.h_mp0n" controls-position="right" :min="0" :max="100" :disabled="temp.status == '1'"></el-input-number>
            </el-form-item>
            <el-form-item label="结束流动相 最小值" prop="h_mp1val_b">
              <el-input-number v-model="temp.h_mp1val_b" controls-position="right" :min="0" :max="100" :disabled="temp.status == '1'"></el-input-number> %
              <el-popover placement="right" width="250" trigger="hover">
                <div v-for="(v, idx) in note.h_mp1val_b" :key="idx">{{v}}</div>
                <i class="el-icon-info info" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="结束流动相 最大值" prop="h_mp1val_e">
              <el-input-number v-model="temp.h_mp1val_e" controls-position="right" :min="0" :max="100" :disabled="temp.status == '1'"></el-input-number> %
            </el-form-item>
            <el-form-item label="结束流动相 个数" prop="h_mp1n">
              <el-input-number v-model="temp.h_mp1n" controls-position="right" :min="0" :max="100" :disabled="temp.status == '1'"></el-input-number>
            </el-form-item>

          </el-form>
        </el-col>
        <!-- base data -->

        <el-col :span="14">
          <div class="head">
            <div class="name">样品参数</div>
            <div class="tip">提示: <i class="el-icon-s-flag"> 特定物质标记</i></div>
          </div>
          <el-table :data="sample.d" max-height="600" stripe border>
            <el-table-column align="center" label="梯度时间(min)" width="80">
              <template slot-scope="scope">
                {{ scope.row[0] }}
              </template>
            </el-table-column>
            <el-table-column label="待测物保留时间/min" align="center">
              <el-table-column align="center" v-for="(v, idx) in sample.s" :key="idx">
                <template #header>
                  <i class="el-icon-s-flag" v-if="sample.f && sample.f.indexOf(idx) > -1"></i>
                  {{ v }}
                </template>
                <template slot-scope="scope">
                  {{ scope.row[idx+1] }} 
                </template>
              </el-table-column>
              <el-table-column label="点击右侧「待测物设置」按钮添加" align="center" v-if="!sample.s || sample.s.length == 0">
              </el-table-column>
            </el-table-column>
            <el-table-column align="center" fixed="right" width="80">
              <template slot="header">
                <span>操作</span>
                <el-tooltip effect="dark" content="待测物设置" placement="top">
                  <el-button type="text" icon="el-icon-setting" @click="setCol"></el-button>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <el-button type="text" icon="el-icon-edit" @click="sdEdit(scope.$index)"></el-button>
                <el-button type="text" icon="el-icon-delete" @click="sdRm(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="act">
            <el-button type="primary" icon="el-icon-circle-plus" size="mini" @click="sdAdd" plain>添加</el-button>
            <el-button type="primary" icon="el-icon-upload2" size="mini" @click="csvShow" plain>CSV导入</el-button>
          </div>
        </el-col>
        <!-- sample data -->

      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dia.edit = false">取消</el-button>
        <el-button type="primary" @click="saveData" v-if="temp.status != '1'">确定</el-button>
      </div>
    </el-dialog>
    <!-- edit -->

    <el-dialog class="dia-sc" title="待测物管理" :close-on-click-modal="false" :visible.sync="dia.s">
      <div slot="title">
        <span>待测物管理</span>
        <i class="s-flag el-icon-s-flag" @click="sc.f = !sc.f" v-if="sc.data && sc.data.length > 0"> 特定物质设定</i>
      </div>
      <div class="box" v-show="!sc.f">
        <el-tag v-for="(tag, idx) in sc.data" :key="tag" closable @close="scRm(tag)">
          <i class="el-icon-s-flag" v-if="sc.flag && sc.flag.indexOf(idx) > -1" ></i>
          {{ tag }}
        </el-tag>
        <el-input class="input-new-tag" v-model="sc.tag" size="small" @keyup.enter.native="scAdd" @blur="scAdd" v-if="sc.swt"></el-input>
        <el-button class="button-new-tag" size="small" @click="sc.swt = true" v-else>+ 添加</el-button>
      </div>
      <div class="box" v-show="sc.f">
        <el-checkbox-group v-model="sc.flag" size="small" :max="2">
          <el-checkbox v-for="(tag, idx) in sc.data" :key="tag" :label="idx" border>{{ tag }}</el-checkbox> 
        </el-checkbox-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <div v-show="!sc.f">
          <el-button @click="dia.s = false">取消</el-button>
          <el-button type="primary" @click="scSave">确定</el-button>
        </div>
        <div v-show="sc.f">
          <el-button type="primary" icon="el-icon-s-flag" @click="sc.f = !sc.f">完成特定物质设定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- sample columns edit -->

    <el-dialog class="dia-sd" title="样品数据" :close-on-click-modal="false" :visible.sync="dia.d">
      <div class="box">
        <el-form label-position="left" label-width="150px" style="margin-left:20px;">
          <el-form-item label="梯度时间(min)">
            <el-input v-model="sd.data[0]"></el-input>
          </el-form-item>
          <el-form-item v-for="(v, idx) in sample.s" :key="idx" :label="v" >
            <el-input v-model="sd.data[idx+1]"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dia.d = false">取消</el-button>
        <el-button type="primary" @click="sdSave">确定</el-button>
      </div>
    </el-dialog>
    <!-- sample data edit -->

    <el-dialog class="dia" title="CSV导入" :close-on-click-modal="false" :visible.sync="dia.csv">
      <div class="box">
        <div class="upload">
          <el-upload ref="csv" drag action :multiple="false" :limit="1" :auto-upload="false" accept=".csv" :on-remove="csvRemove" :on-change="csvChange">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传CSV文件，且不超过500kb, <el-button type="text" size="mini" @click="csvDown">CSV样例下载</el-button></div>
          </el-upload>
        </div>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dia.csv = false">取消</el-button>
        <el-button type="primary" @click="sdCsv">确定</el-button>
      </div>
    </el-dialog>
    <!-- csv upload -->

  </div>
</template>

<script>
import waves from '@/directive/waves'
import Papa from 'papaparse'

const option = {
  status: [{key: '1', val: '已执行'}, {key: '0', val: '初始化'}]
}

export default {
  name: 'WorkForecast',
  directives: {
    waves
  },
  filters: {
    statusFilter(key) {
      let data = option.status.find(row => row.key == key)
      return data.val || '-'
    }
  },
  data() {
    return {
      tableKey: 0,
      list: [],
      total: 0,
      listLoading: true,
      search: {
        page: 1,
        size: 12,
        name: '',
        status: ''
      },
      option: option,
      tip: {
        project: [{k:'intro', n:'项目说明'}, {k:'start', n:'启动时间'}],
        dev: [{k:'sn', n:'序列号'}, {k:'brand', n:'品牌'}, {k:'spec', n:'型号'}, {k:'pip', n:'管线体积ul'}, {k:'grad', n:'梯度延迟体积ml'}, {k:'start', n:'启用时间'}],
        spectrum: [{k:'sn', n:'序列号'}, {k:'brand', n:'品牌'}, {k:'inno', n:'内部编号'}, {k:'plate', n:'理论塔板数'}, {k:'calibre', n:'柱内径mm'}, {k:'len', n:'柱长mm'}, {k:'die', n:'柱死体积ml'}, {k:'start', n:'启用时间'}]
      },
      note: {
        h_duringt: ['我们未来期望的分析时长'],
        h_tptn: ['梯度线段数目可设定为任意整数值，通常可设定为5'],
        h_mp0val_b: ['* 初始流动相组成最小值和最大值规定了初始流动相组成变化的范围，可根据实际需要进行填写', '* 初始流动相组成间隔为流动相组成的递增值。', '* 初始流动相组成的个数=(初始流动相组成最大值-初始流动相组成最小值)÷初始流动相组成间隔＋1', '* 例如，设定初始流动相组成的最小值为10%，最大值为50%，间隔值为2%，则可选择的初始流动相组成的个数为(50%-10%)/2%+1=21'],
        h_mp1val_b: ['* 结束流动相组成最小值和最大值可参考初始流动想组成进行设定', '* 例如，设定结束流动相组成的最小值为50%，最大值为90%，间隔值为2%，则可选择的结束流动相组成的个数为(90%-50%)/2%+1=21'],
        f0:['* 将初始流动相组成（φ0）、终止流动相组成（φ1）、流速（U）等输入页面左侧相应的表格中', '* 初始流动相组成（φ0）和终止流动相组成（φ1）根据我们实际条件填写', '* 如果不确定这个实验条件，可以设定初始流动相组成为10%，终止流动相组成为90%']
      },

      dia: {
        edit: false,
        s: false,
        d: false,
        forecast: false,
        csv: false
      },
      temp: {},
      sample: {
        s: [],
        d: [],
        f: []
      },
      sc: {
        tag: '',
        data: [],
        swt: false,
        flag: [],
        f: false
      },
      sd: {
        idx: -1,
        data: []
      },
      forecast: [],
      csv: {
        h: [],
        d: []
      },

      rules: {
        name: [{ required: true, message: '请填写任务名称', trigger: 'blur' }],
        pid: [{ required: true, message: '请选择项目', trigger: 'change' }],
        did: [{ required: true, message: '请选择机台', trigger: 'change' }],
        sid: [{ required: true, message: '请选择色谱柱', trigger: 'change' }],
        cate: [{ required: true, message: '请选择任务类别', trigger: 'change' }],
        f0: [{ required: true, message: '请填写初始流动相组成', trigger: 'blur' }],
        f1: [{ required: true, message: '请填写终止流动相组成', trigger: 'blur' }],
        vof: [{ required: true, message: '请填写流速', trigger: 'blur' }],
        h_tptn: [{ required: true, message: '请填写梯度线段的数目', trigger: 'blur' }],
        h_duringt: [{ required: true, message: '请填写分析时间', trigger: 'blur' }],
        h_mp0val_b: [{ required: true, message: '请填写初始流动相起始值', trigger: 'blur' }],
        h_mp0val_e: [{ required: true, message: '请填写初始流动相结束值', trigger: 'blur' }],
        h_mp0n: [{ required: true, message: '请填写初始流动相个数', trigger: 'blur' }],
        h_mp1val_b: [{ required: true, message: '请填写结束流动相起始值', trigger: 'blur' }],
        h_mp1val_e: [{ required: true, message: '请填写结束流动相结束值', trigger: 'blur' }],
        h_mp1n: [{ required: true, message: '请填写结束流动相个数', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.init()
    this.getList()
  },
  methods: {
    init() {
      const _t = this
      _t.$http.post('/api/forecast/option').then(resp => {
        _t.option.project = resp.data.project
        _t.option.spectrum = resp.data.spectrum
        _t.option.dev = resp.data.dev
        _t.option.cate = resp.data.cate
      })
    },
    getList() {
      const _t = this
      _t.listLoading = true
      _t.$http.post('/api/forecast', _t.search).then(resp => {
        _t.list = resp.data.list
        _t.total = resp.data.total
        setTimeout(() => {
          _t.listLoading = false
        }, 500)
      }).catch(() => {
        setTimeout(() => {
          _t.listLoading = false
        }, 500)
      })
    },
    handleFilter() {
      this.search.page = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.search.page = val
      this.getList()
    },
    handleCreate() {
      this.temp = {}
      this.sample.s = []
      this.sample.d = []
      this.sample.f = []
      this.dia.edit = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleEdit(row) {
      this.temp = Object.assign({}, row)
      this.sample.s = this.temp.sample && this.temp.sample.s? this.temp.sample.s.slice(0):[]
      this.sample.d = this.temp.sample && this.temp.sample.d? this.temp.sample.d.slice(0):[]
      this.sample.f = this.temp.sample && this.temp.sample.f? this.temp.sample.f.slice(0):[]
      this.dia.edit = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    saveData() {
      const _t = this
      _t.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, _t.temp)
          data.sample = _t.sample
          _t.$http.post('/api/forecast/save', data).then(function(resp) {
            if (resp.code === 0) {
              _t.$message.success(resp.msg)
              _t.dia.edit = false
              _t.getList()
            }
          })
        }
      })
    },
    showInfo(arr, id, kv) {
      let d = []
      if (arr) {
        arr.forEach(row => {
          if (row.id == id) {
            kv.forEach(r => {
              let v = row[r.k]
              let n = r.n
              d.push(`${n}: ${v}`)
            })
            return false
          }
        })
      }
      return d
    },
    setCol() {
      this.sc.swt = false
      this.sc.tag = ''
      this.sc.data = this.sample.s.slice(0)
      this.sc.flag = this.sample.f.slice(0)
      this.sc.f = false
      this.dia.s = true
    },
    scAdd() {
      let tag = this.sc.tag.trim()
      if (tag) {
        if (this.sc.data.indexOf(tag) > -1) {
          this.$message.error('待测物重复')
          return
        }
        this.sc.data.push(tag)
      }
      this.sc.swt = false
      this.sc.tag = ''
    },
    scRm(tag) {
      const _t = this
      let idx = _t.sc.data.indexOf(tag)
      _t.sc.data.splice(idx, 1)
      if (_t.sc.flag) {
        if (_t.sc.flag.indexOf(idx) > -1) {
          _t.sc.flag.splice(_t.sc.flag.indexOf(idx), 1)
        } else {
          _t.sc.flag.forEach((v, i) => {
            if (v > idx) {
              _t.sc.flag[i]--
            }
          })
        }
      }
    },
    scSave() {
      const _t = this
      if (_t.sc.swt) {
        return
      }

      _t.$confirm('待测物保存后，请调整其对应数据, 是否继续?', '提示').then(() => {
        _t.sample.s = _t.sc.data.slice(0)
        _t.sample.f = _t.sc.flag.slice(0)
        _t.dia.s = false
      })
    },
    sdAdd() {
      this.sd.data = []
      this.sd.idx = -1
      this.dia.d = true
    },
    sdEdit(idx) {
      this.sd.data = this.sample.d[idx].slice(0)
      this.sd.idx = idx 
      this.dia.d = true
    },
    sdRm(row) {
      const _t = this
      _t.$confirm('确定删除本条数据, 是否继续?', '提示').then(() => {
        _t.sample.d.splice(this.sc.data.indexOf(row), 1)
      })
    },
    sdSave() {
      let d = this.sd.data.map(x => parseFloat(x))
      if (this.sd.idx == -1) {
        this.sample.d.push(d)
      } else {
        this.$set(this.sample.d, this.sd.idx, d)
      }
      this.dia.d = false
    },
    doTask(id) {
      const _t = this
      _t.$confirm('执行任务后, 各参数数据不可编辑并扣费, 是否继续?', '提示').then(() => {
        let data = {
          id: id
        }
        _t.listLoading = true
        _t.$http.post('/api/forecast/dim', data).then(function(resp) {
          if (resp.code === 0) {
              _t.$router.push({path: '/work/info/' + id})
          }
          _t.listLoading = false
        }).catch(() => {
          setTimeout(() => {
            _t.listLoading = false
          }, 500)
        })
      })
    },
    csvShow() {
      const _t = this
      _t.dia.csv = true
      _t.$nextTick(() => {
        _t.$refs['csv'].clearFiles()
      })
      _t.csv.h = []
      _t.csv.d = []
    },
    csvDown() {
      const d = [
        ['', '30min', '80min'],
        ['S-01', '', ''],
        ['S-02', '', ''],
        ['S-03', '', ''],
        ['S-04', '', ''],
        ['S-05', '', '']
      ]

      // output
      const csv = Papa.unparse(d)
      const blob = new Blob([`\ufeff${csv}`], {type: 'text/csv;charset=utf-8'})
      const url = URL.createObjectURL(blob)

      const a = document.createElement('a')
      a.href = url
      a.download = 'sample.csv'
      a.style.display = 'none'

      document.body.appendChild(a)
      a.click()

      window.URL.revokeObjectURL(url)
      a.remove()
    },
    csvChange(f) {
      const _t = this
      const file = f.raw
      const isCsv = file.type === 'text/csv' || file.type === 'application/vnd.ms-excel'
      const isLt500k = file.size / 1024 < 500

      if (!isCsv) {
        _t.$message.error('请上传CSV文件')
        return
      } 
      if (!isLt500k) {
        _t.$message.error('上传CSV大小不能超过500Kb')
        return
      }

      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        Papa.parse(file, {
          complete: res => {
            _t.csv.h = []
            _t.csv.d = []
            let x = 0, y = 0, s = 2
            let i = 0, j = 0
            for (i = 0; i < res.data.length; i++) {
              // get x position
              let row = res.data[i]
              if (i == 0) {
                for(j = 0; j < row.length; j++) {
                  if (row[j] != '') {
                    x = j 
                  } else if (x < j-s) {
                    break
                  }
                }
              }
              // get y postion
              if (row[0] != '') {
                y = i
              } else if (y < i-s) {
                break
              }
            }

            for (i = 0; i < y; i++) {
              _t.csv.h.push(res.data[i+1][0])
            }

            for (i = 0; i < x; i++) {
              let d = []
              for (j = 0; j <= y; j++) {
                d.push(parseFloat(res.data[j][i+1]))
              }
              _t.csv.d.push(d)
            }
          }
        })
      }
    },
    csvRemove() {
      this.csv.h = []
      this.csv.d = []
    },
    sdCsv() {
      const _t = this
      if (_t.csv.h.length == 0) {
        _t.$message.error('请点击上传CSV文件')
        return
      }

      _t.$confirm('上传的CSV文件会清除原设定的数据, 是否继续?', '提示').then(() => {
        _t.sample.s = _t.csv.h
        _t.sample.d = _t.csv.d
        _t.sample.f = []
        _t.dia.csv = false
      })
    }
  }
}
</script>

<style lang="scss">
.dia {
  .el-form-item {
    margin-bottom: 20px;
  }
  .box {
    .upload {
      text-align: center;
      .el-upload-list {
        font-weight: bold;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.dia {
  .info {
    font-size: 18px;
    margin-left: 10px;
    color: #909399;
    cursor: pointer;
    &:hover {
      color: #409EFF;
    }
  }
  .head {
    margin-bottom: 10px;
    display: flex;
    .name {
      flex: 1;
      font-size: 14px;
      color: #606266;
      font-weight: 700;
    }
    .tip {
      font-size: 12px;
      color: #909399;
    }
  }
  .act {
    margin-top: 10px;
  }
}
.dia-sc {
  .box {
    display: flex;
    flex-wrap: wrap;
    .el-tag, .button-new-tag, .input-new-tag, .el-checkbox {
      margin-left: 10px;
      margin-bottom: 10px;
    }
    .el-tag {
      display: inline-block;
    }
    .button-new-tag {
      height: 32px;
      line-height: 30px;
      padding-top: 0;
      padding-bottom: 0;
    }
    .input-new-tag {
      width: 120px;
      vertical-align: bottom;
    }
  }
  .s-flag {
    font-size: 14px;
    color: #409EFF;
    display: inline-block;
    cursor: pointer;
    margin-left: 20px;
  }
}
</style>
